/*
 * Copyright (c) 2017, Indigen Solutions. All rights reserved.
 *
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 *
 * This software is the confidential and proprietary information.
 *
 * You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement
 * you entered into.
 */

import { get } from "lodash";
import update from "immutability-helper";

export class UpdateRequestBuilder {
    private request: any = {};

    reset(): UpdateRequestBuilder {
        this.request = {};
        return this;
    }

    set(path: string, value: any): UpdateRequestBuilder {
        return this.custom(path, { $set: value });
    }

    push(path: string, value: any): UpdateRequestBuilder {
        return this.custom(path, { $push: [value] });
    }

    concat(path: string, value: any): UpdateRequestBuilder {
        return this.custom(path, { $push: value });
    }

    splice(path: string, start: number, deleteCount: number = Number.MAX_SAFE_INTEGER, ...items: any[]): UpdateRequestBuilder {
        let oldSplices = get(this.request, `${path}.$splice`, []);
        let newSplice = [start].concat([deleteCount], items);
        return this.custom(path, { $splice: oldSplices.concat([newSplice]) });
    }

    merge(path: string, object: any): UpdateRequestBuilder {
        return this.custom(path, { $merge: object });
    }

    custom(path: string, action: any): UpdateRequestBuilder {
        let current: any = this.request;
        path.split(".").forEach((part) => {
            current[part] = current[part] || {};
            current = current[part];
        });
        Object.assign(current, action);
        return this;
    }

    apply(path: string, cb: any): UpdateRequestBuilder {
        return this.custom(path, {$apply: cb});
    }

    build(): any {
        return this.request;
    }

    exec<T>(data: T): T {
        return update(data, this.build());
    }
}


// WEBPACK FOOTER //
// ./src/utils/UpdateRequestBuilder.ts